import React from 'react';

export interface BadgeProps {
  variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'paypal' | 'stripe' | 'stripe-api';
  size?: 'sm' | 'md';
  className?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  size = 'md',
  className = '',
  children,
}) => {
  const baseClasses = 'inline-flex items-center font-bold rounded-full';
  
  const variantClasses: Record<string, string> = {
    success: 'bg-emerald-500/15 text-emerald-600 border border-emerald-500/30',
    warning: 'bg-amber-500/15 text-amber-600 border border-amber-500/30',
    error: 'bg-red-500/15 text-red-600 border border-red-500/30',
    info: 'bg-blue-500/15 text-blue-600 border border-blue-500/30',
    neutral: 'bg-slate-500/15 text-slate-500 border border-slate-500/30',
    // PayPal - Couleur officielle bleu PayPal
    paypal: 'bg-[#0070BA]/15 text-[#003087] border border-[#0070BA]/30',
    // Stripe Connect - Couleur officielle violet Stripe
    stripe: 'bg-[#635BFF]/15 text-[#635BFF] border border-[#635BFF]/30',
    // Stripe API Key - Indigo/slate pour différencier
    'stripe-api': 'bg-indigo-500/15 text-indigo-600 border border-indigo-500/30',
  };
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs',
  };
  
  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  
  return (
    <span className={combinedClasses}>
      {children}
    </span>
  );
};

export default Badge;

